const CONSULTANT_ERROR_MESSAGES: Record<string, string> = {
  CONSULTANT_CUSTOMER_DENIED: 'Cliente fora da sua carteira.',
  CONSULTANT_DISTRIBUTOR_DENIED: 'Distribuidora fora da sua carteira.',
  CONSULTANT_CUSTOMER_REGION_DENIED: 'Cliente não atende na região selecionada.',
  CONSULTANT_DISTRIBUTOR_REGION_DENIED: 'Distribuidora não atua na região selecionada.',
  CONSULTANT_REGION_DENIED: 'Região não pertence à sua carteira.',
  CONSULTANT_DISTRIBUTOR_QUOTE_DENIED: 'Cotação de distribuidora fora da sua carteira.',
  CONSULTANT_NOT_FOUND: 'Consultor não encontrado para o usuário autenticado.',
  CONSULTANT_USER_ALREADY_LINKED: 'Este usuário já está vinculado a um consultor.',
};

export function getConsultantErrorMessage(code?: string | null): string | null {
  if (!code) return null;
  return CONSULTANT_ERROR_MESSAGES[code] ?? null;
}
